@if (
  {
    project: projectView$ | async,
    usersMap: usersMap$ | async,
    timeLeft: timeLeft$ | async,
    repeatingTaskHistoryMap: repeatingTaskHistoryMap$ | async,
    tasks: tasks$ | async
  };
  as state
) {
  @if (loading$ | async) {
    <div class="loading-container">
      <oph-loading></oph-loading>
    </div>
  } @else {
    <div class="content-container">
      <div class="content-container-row">
        <!-- -------------------------------------PROGRESS------------------------------------ -->
        <div class="content-item progress">
          <project-view-item-header text="Progress" class="mb-10" />
          <project-view-progress
            [percentComplete]="$any(state.project?.progress?.percentComplete || 0)"
          ></project-view-progress>
          <span class="progress-text">{{ progressText$ | async }} </span>
        </div>

        <!-- -------------------------------------TIME LEFT------------------------------------ -->
        <div class="content-item progress">
          <project-view-item-header text="Time left" class="mb-10" />
          <project-view-progress [percentComplete]="state.timeLeft?.percentage"></project-view-progress>
          <span class="progress-text"> {{ state.timeLeft?.display }}</span>
        </div>

        <!-- -------------------------------------TOKENS------------------------------------ -->
        <div class="content-item wrap-item flex-column milestones">
          <project-view-item-header
            text="Tokens"
            color="orange-2"
            class="mb-15"
            [tokenFilters]="true"
            (tokenTimeFilterChange)="onTokenTimeFilterChange()"
          />
          <div class="token-container oph-scroll-bar">
            @if ((displayTokens$ | async)?.length) {
              @for (t of state.project.tokens; track $index) {
                @if (t?.token?.name && t?.token?.icon) {
                  <oph-icon
                    [name]="'tokens/' + t?.token?.icon"
                    [size]="35"
                    [matTooltip]="
                      t?.token?.name +
                      '\n' +
                      (state.usersMap?.[t.earnedBy]?.username || '(Name not found)') +
                      '\n' +
                      (t.earnedAt | convertUtcToTimezone: 'MMM D, y h:mm a')
                    "
                    matTooltipClass="white-space-pre-line"
                  ></oph-icon>
                }
              }
            } @else {
              <div class="empty">No tokens</div>
            }
          </div>
        </div>
      </div>

      <!-- -------------------------------------MILESTONES (hidden - might come back)------------------------------------ -->
      <!-- <div class="content-item wrap-item flex-column milestones">
        <project-view-item-header text="Milestones" color="gold" class="mb-15" />
        <div class="milestones-container oph-scroll-bar">
          @if (state.project?.milestones?.length) {
            @for (milestone of state.project.milestones || []; track milestone) {
              <project-view-line-item icon="flag-gold" padding="8px 0">
                <project-view-milestone [milestone]="milestone"></project-view-milestone>
              </project-view-line-item>
            }
          } @else {
            <div class="empty empty-milestones">No milestones</div>
          }
        </div>
      </div> -->

      <!-- -------------------------------------ACTIVITY------------------------------------ -->
      <div class="content-container-row">
        <div class="content-item activity">
          <project-view-item-header text="Activity" color="yellow" class="mb-15" />
          <div class="activity-container oph-scroll-bar">
            @if (state.project?.activity?.length) {
              @for (item of state.project.activity; track item) {
                <project-view-line-item [icon]="item.action | projectViewActivityIcon" padding="7px 0">
                  <project-view-activity-item
                    [activityItem]="item"
                    [user]="state.usersMap[$any(item).userId]"
                  ></project-view-activity-item>
                </project-view-line-item>
              }
            } @else {
              <div class="empty">No activity</div>
            }
          </div>
        </div>

        <!-- -------------------------------------TRACKERS------------------------------------ -->
        <div class="content-item wrap-item trackers-item">
          <project-view-item-header
            text="Trackers"
            color="orange"
            class="mb-15"
            [addNewButton]="true"
            [addNewButtonRolePermissionNeeded]="rolePermissionOptions.Trackers"
            [addNewButtonLoading]="addNewButtonLoading$ | async"
            (addNewButtonClick)="onAddTracker()"
          />
          <div class="trackers-container oph-scroll-bar">
            @if (state.project?.trackers?.length) {
              @for (formattedTracker of (formattedTrackers$ | async) || []; track formattedTracker) {
                <project-view-tracker
                  [tracker]="formattedTracker.tracker"
                  [mostRecentlyUpdatedMetricIndex]="formattedTracker.mostRecentlyUpdatedMetricIndex"
                ></project-view-tracker>
              }
            } @else {
              <div class="empty">No trackers</div>
            }
          </div>
        </div>
      </div>

      <!-- -------------------------------------TASKS------------------------------------ -->

      <div class="content-container-row">
        <div class="content-item full-width">
          <project-view-item-header text="Tasks" />
          @if (state.tasks?.length) {
            @for (task of state.tasks; track task) {
              <project-view-task
                [task]="task"
                [usersMap]="state.usersMap"
                [repeatingTaskHistory]="state.repeatingTaskHistoryMap[task.taskInstanceId]"
                (taskClick)="onTaskClick($event)"
                (pageChange)="onPageChange($event, task.taskInstanceId)"
                (checkboxClick)="onCheckbox($event)"
              ></project-view-task>
            }
          } @else {
            <div class="empty">No tasks</div>
          }
        </div>
      </div>
    </div>
  }
}
